var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elfsight-app-516d5ddc-10cc-46a8-8d13-26da5f9fb7d4",attrs:{"data-elfsight-app-lazy":""}})}
var staticRenderFns = []

export { render, staticRenderFns }